import ajax from '@/utils/ajax';

export default {
    get: (hash, delegation) => ajax.get(`/api/newShips/${hash}`, {params: {delegation: delegation || ""}}),
    getMerge: (hash, delegation) => ajax.get(`/api/newShips/${hash}/merge`, {params: {delegation: delegation || ""}}),
    getSimple: hash => ajax.get(`/api/newShips/${hash}/simple`),
    getSimpleByName: name => ajax.get("/api/newShips/simpleByName", {params: {name}}),
};
